import React from 'react';
import './HorizontalRuleLarge.css';

const HorizontalRuleLarge = () => <hr className="horizontal-rule-large" />;

export default HorizontalRuleLarge;



// WEBPACK FOOTER //
// ./src/components/HorizontalRuleLarge/HorizontalRuleLarge.jsx